import React, { useState } from 'react';
import { Popover, PopoverHeader, PopoverBody, Button } from 'reactstrap';

const TrackingPagoTooltip = ({ trackingPago, facturaId }) => {
  if (!trackingPago) return null;

  const popoverId = `tracking-${facturaId}`;
  const [popoverOpen, setPopoverOpen] = useState(false);

  const formatCurrency = (value, currency = 'Bs') => {
    if (!value && value !== 0) return 'N/A';
    return new Intl.NumberFormat('es-VE', {
      style: 'decimal',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
      useGrouping: true
    }).format(parseFloat(value)) + ` ${currency}`;
  };

  const togglePopover = () => {
    setPopoverOpen(!popoverOpen);
  };

  const formatDate = (dateString) => {
    if (!dateString) return 'N/A';
    const date = new Date(dateString);
    return date.toLocaleDateString('es-ES', {
      year: 'numeric',
      month: 'short',
      day: 'numeric'
    });
  };

  return (
    <>
      <Button
        color="link"
        className="p-0 text-info"
        id={popoverId}
        style={{ fontSize: '1.1rem', lineHeight: 1 }}
      >
        <i className="ri-information-line"></i>
      </Button>
      <Popover 
        placement="left" 
        target={popoverId}
        isOpen={popoverOpen}
        toggle={togglePopover}
        trigger="legacy"
      >
        <PopoverHeader>
          <strong>Tracking de Pago</strong>
        </PopoverHeader>
        <PopoverBody>
          {trackingPago.numeroSiniestro && (
            <div className="mb-1">
              <small>N° Siniestro: {trackingPago.numeroSiniestro}</small>
            </div>
          )}
          
          {trackingPago.fechaPago && (
            <div className="mb-1">
              <small>Fecha Pago: {formatDate(trackingPago.fechaPago)}</small>
            </div>
          )}

          {trackingPago.cheque && (
            <div className="mb-1">
              <small>Cheque: {trackingPago.cheque}</small>
            </div>
          )}
          
          {trackingPago.montoPagadoBs && (
            <div className="mb-1">
              <small>Monto Pagado: {formatCurrency(trackingPago.montoPagadoBs, 'Bs')}</small>
            </div>
          )}
          
          {trackingPago.diferenciaPagoBs && parseFloat(trackingPago.diferenciaPagoBs) !== 0 && (
            <div className="mb-1">
              <small className="text-warning">
                Diferencia: {formatCurrency(Math.abs(parseFloat(trackingPago.diferenciaPagoBs)), 'Bs')}
              </small>
            </div>
          )}
          
          {parseFloat(trackingPago.deducibleBs || 0) > 0 && (
            <div className="mb-1">
              <small>Deducible: {formatCurrency(trackingPago.deducibleBs, 'Bs')}</small>
            </div>
          )}
          
          {parseFloat(trackingPago.noAmparadoBs || 0) > 0 && (
            <div className="mb-1">
              <small>No Amparado: {formatCurrency(trackingPago.noAmparadoBs, 'Bs')}</small>
            </div>
          )}
          
          {trackingPago.observacionesPago && (
            <div className="mt-2 pt-2 border-top">
              <small className="text-warning">
                <i className="ri-alert-line me-1"></i>
                <strong>Observaciones:</strong>
                <div className="mt-1">{trackingPago.observacionesPago}</div>
              </small>
            </div>
          )}
          
          {trackingPago.fechaImportacion && (
            <div className="mt-2 pt-2 border-top">
              <small className="text-muted">
                Importado: {formatDate(trackingPago.fechaImportacion)}
              </small>
            </div>
          )}
        </PopoverBody>
      </Popover>
    </>
  );
};

export default TrackingPagoTooltip;
